export default __webpack_public_path__ + "static/media/Goal_2.2f09d1ae.zip";